import $ from 'jquery'

$(document).ready(function() {
    const eduman = document.querySelector(".landingSection svg")
    const eduman2 = document.querySelector(".aboutContentContainer > svg")
    let isFirstrun = true
    let isFirstRun2 = true
    const options = {
        root: null,
        threshhold: .25,
        rootMargin: "-30% 0%"
    }

    const edumanObserver = new IntersectionObserver(function(entries, edumanObserver){
        entries.forEach(entry => {
            if(!entry.isIntersecting){
                entry.target.classList.remove("edumanLeftUnInvis")
                entry.target.classList.add("edumanRightInvis")
                isFirstrun = false
            }else{
                entry.target.classList.remove("edumanRightInvis")
                if(isFirstrun) {
                    return
                }
                else{
                    entry.target.classList.add("edumanLeftUnInvis")
                }
            }
        })
    }, options)

    const edumanObserver2 = new IntersectionObserver(function(entries, edumanObserver2){
        entries.forEach(entry => {
            if(!entry.isIntersecting){
                entry.target.classList.add("edumanLeftUnInvisInverse")
                entry.target.classList.remove("edumanRightInvisInverse")
                isFirstRun2 = false
            }else{
                entry.target.classList.add("edumanRightInvisInverse")
                if(isFirstRun2) {
                    return
                }
                else{
                    entry.target.classList.remove("edumanLeftUnInvisInverse")
                }
            }
        })
    }, options)

    if(edumanObserver && edumanObserver2){
        try{
            edumanObserver.observe(eduman)
            edumanObserver2.observe(eduman2)
        }
        catch(e){
            return;
        }
    }

})